<template>
  <div id="app">
    <b-navbar toggleable="lg" type="dark" variant="primary">
      <b-navbar-brand to="/" tag="router-link">Luanva</b-navbar-brand>

      <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

      <b-collapse id="nav-collapse" is-nav>
        <b-navbar-nav class="ml-auto">
          <!-- Si el usuario está autenticado -->
          <template v-if="isAuthenticated">
            <b-nav-item to="/articulos" tag="router-link">Articulos</b-nav-item>
            <b-nav-item to="/sales" tag="router-link">Ventas</b-nav-item>
            <b-nav-item to="/venta" tag="router-link">Nueva Venta</b-nav-item>

            <b-nav-item-dropdown right>
              <template #button-content> 👤 {{ user.name }} </template>
              <b-dropdown-item @click="logoutUser"
                >Cerrar sesión</b-dropdown-item
              >
            </b-nav-item-dropdown>
          </template>

          <!-- Si NO está autenticado -->
          <template v-else>
            <b-nav-item to="/login" tag="router-link"
              >Iniciar sesión</b-nav-item
            >
          </template>
        </b-navbar-nav>
      </b-collapse>
    </b-navbar>

    <router-view />
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

export default {
  computed: {
    ...mapGetters("auth", ["isAuthenticated", "user"]),
  },
  methods: {
    ...mapActions("auth", ["logout"]),
    async logoutUser() {
      try {
        await this.logout();
        this.$router.push("/login");
      } catch (e) {
        console.error("Error al cerrar sesión", e);
      }
    },
  },
};
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

b-navbar {
  margin-bottom: 20px;
}

router-view {
  flex: 1;
}
</style>
